import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import ReactDOM from 'react-dom';
import { KeyboardArrowRight } from '@material-ui/icons';
import { Link } from 'react-router-dom';

import Categories from '../../../components/generalComponents/Categories';

// utils
import callApi from '../../../utils/callApi';

// constants
import { CATEGORY_LIST_URL, BLOG_POST } from '../../../constants/apiUrls/apiUrls';
import SimpleVideoPlayer from '../../../components/blogComponents/SimpleVideoPlayer';
import LockedVideo from '../../../components/videoComponents/LockedVideo';
import { useBlog } from '../../../hooks/useBlog';


export const BlogPage = ({ user, location, match }) => {

  const { categories } = useBlog();
  const [blog, setBlog] = useState(undefined);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchBlog();
  }, [location, match]);

  useEffect(() => {
    const isExpired = user.authenticated && !user.user.activeSubscription;
    const isAnchor = user.user && user.user.account.anchor;
    if (videos === null) {
      return false;
    }
    videos.forEach((v) => {
      const el = document.getElementById(`vp_${v[0]}`);
      if (el) {
        (!isExpired || isAnchor) ? el && ReactDOM.render((<SimpleVideoPlayer clip={v[1]} user={user} />), el) : el && ReactDOM.render((<div style={{ fontSize: '14px' }}><LockedVideo videoElement={v[1]} /></div>), el);
      } else {
        console.log('unable to display video - no target element found.');
      }
    });
  }, [videos]);

  const fetchBlog = async() => {
    const id = getIdFromUrl();
    const url = BLOG_POST.replace('{id}', id);

    const res = await callApi(url, 'get', {});
    const regex = /<div class="video-player" data-video="(.*?)">(.*?)(.|[\r\n])(.*?)<div id="vp_(.*?)"/g;
    const videos = [];
    const txt = res.data.content;
    let match = regex.exec(txt);
    while (match != null) {
      const jsonData = match[1];
      const id = match[5];
      videos.push([id, JSON.parse(unescapeHtml(jsonData))]);
      match = regex.exec(txt);
    }
    document.title = res.data.title;
    setBlog(res.data);
    setVideos(videos);
  };

  const unescapeHtml = (html) => {
    const el = document.createElement('div');

    return html.replace(/&[#0-9a-z]+;/gi, (enc) => {
      el.innerHTML = enc;

      return el.innerText;
    });
  };

  const renderTags = () => {
    const blogLength = blog.blogTags.length;

    return blog.blogTags.map((tag, index) => (
      <Link key={tag.id} title={tag.name} to={`/news/tag/${tag.slug}`}>{tag.name + ((blogLength - 1 === index) ? '' : ', ')}</Link>
    ));
  };

  const renderCategories = () => {
    const blogLength = blog.blogCategories.length;

    return blog.blogCategories.map((categ, index) => (
      <Link key={categ.id} title={categ.name} to={`/news/category/${categ.id}`}>{categ.name + ((blogLength - 1 === index) ? '' : ', ')}</Link>
    ));
  };

  const getIdFromUrl = () => {
    const regex = /---(\d+)/g;
    const found = location.pathname.match(regex);

    if (typeof match !== 'undefined') {
      return match.params.id;
    }

    if (found.length) {
      return found[0].replace('---', '');
    }

    return null;
  };

  return blog ? (
    <div className="content soft-white">
      <div className="container">
        <div id="blog_breadcrumb">
          <ol className="breadcrumb">
            <li className="false">
              <Link to="/news">{/* {blog.authorName}  */}News</Link>
            </li>
            <KeyboardArrowRight fontSize="large" />
            {blog.blogCategories && blog.blogCategories[0] && (
              <>
                <li className="false">
                  <Link to={`/news/category/${blog.blogCategories[0].id}`}>{blog.blogCategories[0].name}</Link>
                </li>
                <KeyboardArrowRight fontSize="large" />
              </>
            )}
            <li className="active">{blog.title}</li>
          </ol>
        </div>
        <div className="show-page" id="blog_posts">
          <div className="row-r">
            <div className="col-md-8 col-sm-12 col-xs-12">
              <article className="bg-white blog-post" itemType="http://schema.org/BlogPosting">
                <span className="post-creds">
                  {`${moment(blog.date).format('LLLL')} BY ${blog.authorName}`}
                </span>
                <h1 className="h2">{blog.title}</h1>
                <div className="post-content" style={{ width: '100%', overflow: 'hidden' }}>
                  {/* { blog.imageUrl &&*/}
                  {/* <img className="img-responsive" src={blog.imageUrl} alt="null" />*/}
                  {/* }*/}
                  <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                </div>
                <div>
                  <small>
                    <strong>Tags:</strong>
                    {renderTags()}
                  </small>
                </div>
                <div>
                  <small>
                    <strong>Categories:</strong>
                    {renderCategories()}
                  </small>
                </div>
              </article>
              <p className="h2">
                {blog.commentQuestion}
              </p>
            </div>
            <div className="runner col-md-4 col-sm-12 col-xs-12">
              <div className="runner">
                <div className="runner-side">
                  <p className="h2">Categories</p>
                  <Categories categories={categories} containerClass="list-unstyled" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default BlogPage;
